import { h } from "preact";

import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function AmbassadorOnboardedDialog(props) {
	const handleClose = () => {
		props.onClose();
	};

	const acceptDealAsAmbassador = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/1c2e9a825a224b7bb43b65e9afa6c422/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//window.location.reload();
						window.location.href = "/dashboarda"
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Félicitations
				</Typography>
			</DialogTitle>
			<DialogContent dividers>

				{/* <Typography variant="body1">Félicitations</Typography> */}

				<Typography variant="body1">Vous avez complété votre profil ambassadeur.</Typography>
				<Typography variant="body1">Voulez-vous aller au tableau de bord ambassadeur?</Typography>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="center" style="width: 100%">
					{/* <Box>
						<Button onClick={handleClose}>Annuler</Button>
					</Box> */}
					<Box>
						<Button onClick={() => {
							acceptDealAsAmbassador();

						}} variant="contained">
							Aller à mon tableau de bord
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
